// -----------------------------------------------------------------------------
// <copyright file="warning-with-checkbox.component.ts" company="ecoInsight, Inc.">
// 	Copyright © ecoInsight, Inc. All rights reserved.
// </copyright>
// ------------------------------------------------------------------------------

import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { warningWithCheckboxModel } from './warning-with-checkbox.model';
import { SharedModule } from '../../shared.module';

@Component({
  selector: 'fs-warning-with-checkbox',
  templateUrl: './warning-with-checkbox.component.html',
  styleUrls: ['./warning-with-checkbox.component.scss'],
  imports: [SharedModule],
  encapsulation: ViewEncapsulation.None,
})
export class WarningWithCheckboxComponent {
  @Input() public data?: warningWithCheckboxModel;
  @Output() public action = new EventEmitter<{ action: string; payload?: any }>();
  public isDntShowClicked = false;

  public close(): void {
    this.action.emit({ action: 'Close', payload: null });
  }

  public save(): void {
    this.action.emit({ action: 'Save', payload: { isDntShowClicked: this.isDntShowClicked } });
  }
}
